import { colors } from '@/theme'
import type { ProductRow } from '@/types/product'
import { getPrescriptionType } from '@/types/product'
import { Chip } from '@mui/material'
import type { GridColDef } from '@mui/x-data-grid'

export type ProductRowType = ProductRow

const prescriptionTypeColors: Record<string, { bg: string; text: string }> = {
  POM: { bg: colors.status.errorLight, text: colors.status.error },
  P: { bg: colors.status.warningLight, text: colors.status.warning },
  GSL: { bg: colors.status.successLight, text: colors.status.success },
  'POM-V': { bg: colors.brand.primaryLight, text: colors.brand.primary },
  'N/A': { bg: colors.grey[100], text: colors.grey[600] }
}

export const columns: GridColDef<ProductRowType>[] = [
  {
    field: 'variant_title',
    headerName: 'VariantTitle',
    flex: 1.2,
    minWidth: 200
  },
  {
    field: 'product_title',
    headerName: 'Product Title',
    flex: 1.2,
    minWidth: 200
  },
  {
    field: 'quantity',
    headerName: 'Quantity',
    flex: 0.7,
    minWidth: 120
  },
  {
    field: 'strength',
    headerName: 'Strength',
    flex: 0.8,
    minWidth: 120
  },
  {
    field: 'variant_sku',
    headerName: 'SKU',
    flex: 0.8,
    minWidth: 120
  },
  {
    field: 'categories',
    headerName: 'Categories',
    flex: 1,
    minWidth: 180,
    valueGetter: (_value, row) => row.categories?.map(c => c.name).join(', ') || '-'
  },
  {
    field: 'prod_group',
    headerName: 'Prescription Type',
    flex: 0.8,
    minWidth: 140,
    valueGetter: (_value, row) => getPrescriptionType(row.prod_group),
    renderCell: params => {
      const type = params.value as string
      const colorConfig = prescriptionTypeColors[type] || prescriptionTypeColors['N/A']
      return (
        <Chip
          label={type}
          size='small'
          sx={{
            bgcolor: colorConfig.bg,
            color: colorConfig.text,
            fontWeight: 500,
            fontSize: 12
          }}
        />
      )
    }
  },
  {
    field: 'price',
    headerName: 'Price',
    flex: 0.6,
    minWidth: 100,
    valueGetter: (_value, row) => {
      const p = Number.parseFloat(row.price)
      return Number.isNaN(p) ? null : p
    },
    valueFormatter: value => {
      if (value === null || value === undefined) return '-'
      return `£${Number(value).toFixed(2)}`
    }
  },
  {
    field: 'is_in_stock',
    headerName: 'In Stock',
    flex: 0.5,
    minWidth: 90,
    type: 'boolean',
    renderCell: params => (
      <Chip
        label={params.value ? 'Yes' : 'No'}
        size='small'
        sx={{
          bgcolor: params.value ? colors.status.successLight : colors.status.errorLight,
          color: params.value ? colors.status.success : colors.status.error,
          fontWeight: 500,
          fontSize: 12
        }}
      />
    )
  }
]
